"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.retry = retry;
const adapter_1 = require("../../api/adapter");
const errors_deprecated_1 = require("../errors-deprecated");
function retry(retryMax, retryDelay, fn, logger) {
    return new Promise((resolve, reject) => {
        let retryCount = 0;
        const retryFn = () => {
            fn(retryCount)
                .then(resolve)
                .catch((err) => {
                if (++retryCount < retryMax) {
                    logger === null || logger === void 0 ? void 0 : logger.warn(`retrying ${retryCount} time(s)`, { err: (0, errors_deprecated_1.wrapNativeError)(err) });
                    adapter_1.device.setTimeout(retryFn, retryDelay);
                }
                else {
                    reject(err);
                }
            });
        };
        retryFn();
    });
}
//# sourceMappingURL=retry.js.map